<button class="button" fxHide fxShow.gt-sm mat-button (click)="toggleFullscreen()" fxFlex="grow"
  [attr.aria-label]="isFullscreen ? 'Exit fullscreen mode' : 'Enter fullscreen mode'" [attr.aria-pressed]="isFullscreen"
  [matTooltip]="LangTextData.tooltipLabel.toolBoxFullScreen" matTooltipClass="table_tooltip_job_filename" matTooltipPosition="below">
  <mat-icon *ngIf="!isFullscreen" aria-hidden="true">fullscreen</mat-icon>
  <mat-icon *ngIf="isFullscreen" aria-hidden="true">fullscreen_exit</mat-icon>
</button>